import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HTML_ERRORS } from '@commoncore/constants/htmlErrors';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'lib-passphrase-login',
  templateUrl: './passphrase-login.component.html',
  styleUrls: ['./passphrase-login.component.scss'],
  imports:[DependenciesModule]
})
export class PassphraseLoginComponent implements OnInit {
  universalService: any;
  controller: any;
  implRef: any;
  router: any;
  localStorageSvc: LocalStorageSvc;
  cleverTapEventsService:CleverTapEventsService;
  password;
  show:boolean = false;
  sessionStorageService:any;

  constructor(public globalService: GlobalService,private activatedRoute:ActivatedRoute) {
    this.setEnvObjects(globalService)
    // this.password === 'password'
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && !this.universalService.iframeLogin) {
      this.logOutUser();
    }
  }

  ngOnInit() {
    this.controller=UserloginController.getInstance(this.globalService);
    this.implRef = this.controller.userLoginImplementation;
    setTimeout(() => {
      document.getElementById("passPhraseInput").focus();
    }, 500);
    
    this.implRef.isPassPhraseLoginError = false;
    if(localStorage.getItem('invalidPassPhraseCounter') != null){
      this.implRef.invalidPassPhraseCounter = JSON.parse(localStorage.getItem('invalidPassPhraseCounter'));
      if(this.implRef.invalidPassPhraseCounter == 0){
        this.implRef.isPassPhraseLoginError = true;
        this.implRef.resetInavlidPassPhraseCounter()
      }else if(this.implRef.invalidPassPhraseCounter == 1){
        this.implRef.exception.errorMessage = HTML_ERRORS["LOCK_APP_WARNING"];
      }
    }
    this.cleverTapEventsService.passphraseScreenViewed('Enter passphrase');
  }

  setEnvObjects(globalService){
    this.universalService = this.globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
  }
  
  async validate2FA(passPharse){
    
    // if(localStorage.getItem("appunlockTime") === null && localStorage.getItem("appLockTime") === null){
      if(this.implRef.enablePassPhraseSubmitButton ){
        this.implRef.enablePassPhraseSubmitButton = false;
        var result = await this.implRef.genratePassPhraseHash(passPharse);
        if(result){
          this.controller.validate2FA(); 
        }
      }
    // }
  }

  validatePassPharse(passPharse){    
    let input = passPharse.value.replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?\-_/\s]/g, '');
    passPharse.value = input;
    this.implRef.enablePassPhraseSubmitButton = false;
    // this.implRef.enablePassPhraseSubmitButton = true;
    if(passPharse.value == "" || passPharse.value.trim().length == 0 || passPharse.value.trim().length<6){
      this.implRef.isPassPhraseLoginError = true;
      this.implRef.exception.errorMessage =  'Passphrase length should be between 6 to 20 characters,' 
      this.implRef.enablePassPhraseSubmitButton = false;
    }else{
      if(passPharse.value.trim().length>= 6 && localStorage.getItem("appunlockTime") === null && localStorage.getItem("appLockTime") === null){
        this.implRef.isPassPhraseLoginError = false;
        this.implRef.enablePassPhraseSubmitButton = true;
        this.implRef.exception.errorMessage =  '' ;
        this.implRef.is2FAForPrivateFolder = false;
      }
    }
  }

  async logOutUser(){
    let userData = this.localStorageSvc.getUserData(true);
    if(this.implRef.is2FAForPrivateFolder == true) {
      this.universalService.disableModalBackdrop();
      this.universalService.show2FApopUp = false;
      this.implRef.is2FAForPrivateFolder = false;
      return;
    }    
    setTimeout(() => {
      if (confirm("You will be logged out of JioAICloud")) {
        this.controller.twoFALogout();
      } else {
        return
      }
    }, 300);
   
    
  }

  forgotPassPhrase(){
    this.cleverTapEventsService.forgotPassphraseClicked();
    this.cleverTapEventsService.passphraseScreenViewed('Forgot passphrase')
    this.universalService.showPassPhraseReset = true
    this.universalService.show2FApopUp = false;
    this.universalService.isPassphraseReset = true;
    this.universalService.forgotPassPhraseModalOpned = true;
    this.implRef.is2FAForPrivateFolder = false;
  }

  showHidePaasword() {
    
    let inputEl = document.getElementById("passPhraseInput") as any ; 
    if (inputEl.type === 'password') {
      inputEl.type="text"
      this.show = true;
    } else {
      inputEl.type = 'password';
      this.show = false;
    }
  }

  focusOnInputField(){
    setTimeout(() => {
      document.getElementById('passPhraseInput').focus();
    }, 1);
  }


}
